import classNames from 'classnames'
import { JSX, ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'

import styles from './Button.module.scss'

interface ButtonProps {
  className?: string
  children?: React.ReactNode
  disabled?: boolean
  loading?: boolean
  fixedBottom?: boolean
  rounded?: boolean
  prefix?: ReactNode
  onClick?(): void
  navigate?: string
  type?: 'primary' | 'secondary' | 'link' | 'gold'
  size?: 's' | 'm'
}

export const Button = ({
  className,
  children,
  onClick,
  disabled,
  prefix,
  fixedBottom,
  loading,
  navigate,
  type = 'primary',
  size = 'm',
  rounded,
}: ButtonProps): JSX.Element => {
  const handleNavigate = useNavigate()

  return (
    <div
      className={classNames(
        styles.root,
        styles[`type-${type}`],
        styles[`size-${size}`],
        fixedBottom && styles.fixedBottom,
        disabled && styles.disabled,
        loading && styles.loading,
        rounded && styles.rounded,
        className
      )}
      onClick={() => {
        if (!disabled && !loading && onClick) {
          onClick()
        }

        if (!disabled && !loading && navigate) {
          handleNavigate(navigate)
        }
      }}
    >
      {loading ? <div className={styles.loader} /> : null}
      {!loading && prefix ? (
        <div className={styles.prefix}>{prefix}</div>
      ) : null}
      {!loading ? children : null}
    </div>
  )
}
